import {
  Heart,
  Baby,
  Cake,
  Gem,
  Presentation,
  GraduationCap,
  PartyPopper,
  Users,
  Camera,
  BookOpen,
  Church,
  Briefcase,
  Flame,
  MoreHorizontal,
} from "lucide-react";

export const ServiceModel = {
  id: "",
  available: true,
  description: "",
  title: "",
  icon: null,
};

export const Services = [
  {
    id: "service_1",
    available: true,
    description:
      "Prestigious venues and personalized attention for your anniversary celebrations.",
    title: "Anniversaries",
    icon: Heart,
    color: "rose",
  },
  {
    id: "service_2",
    available: true,
    description:
      "Elegant settings for welcoming new beginnings at baby showers.",
    title: "Baby Showers",
    icon: Baby,
    color: "pink",
  },
  {
    id: "service_3",
    available: true,
    description:
      "Tailored and refined birthday party experiences for lasting memories.",
    title: "Birthday Parties",
    icon: Cake,
    color: "amber",
  },
  {
    id: "service_4",
    available: true,
    description:
      "Luxurious bridal shower events in the most elegant of atmospheres.",
    title: "Bridal Showers",
    icon: Gem,
    color: "purple",
  },
  {
    id: "service_5",
    available: true,
    description:
      "Professional and upscale conference facilities for impactful gatherings.",
    title: "Conferences",
    icon: Presentation,
    color: "blue",
  },
  {
    id: "service_6",
    available: true,
    description:
      "Celebrate academic success in our sophisticated and stately graduation venues.",
    title: "Graduations",
    icon: GraduationCap,
    color: "indigo",
  },
  {
    id: "service_7",
    available: true,
    description:
      "Host festive holiday parties in our exclusive and premier event spaces.",
    title: "Holiday Parties",
    icon: PartyPopper,
    color: "red",
  },
  {
    id: "service_8",
    available: true,
    description:
      "Conduct your meetings in our distinguished spaces designed for productivity.",
    title: "Meetings",
    icon: Users,
    color: "slate",
  },
  {
    id: "service_9",
    available: true,
    description:
      "Capture the moment with our deluxe photo booth rentals for any upscale event.",
    title: "Photo Booth Rental",
    icon: Camera,
    color: "cyan",
  },
  {
    id: "service_10",
    available: true,
    description:
      "Elevate your seminars with our first-class facilities and services.",
    title: "Seminars",
    icon: BookOpen,
    color: "teal",
  },
  {
    id: "service_11",
    available: true,
    description:
      "Plan your dream wedding in our magnificent and grandiose event halls.",
    title: "Weddings",
    icon: Church,
    color: "yellow",
  },
  {
    id: "service_12",
    available: true,
    description:
      "Organize your corporate events at our exclusive venue for a prestigious affair.",
    title: "Work Events",
    icon: Briefcase,
    color: "emerald",
  },
  {
    id: "service_13",
    available: true,
    description:
      "Embrace tradition with elegance in our specially curated event experiences.",
    title: "Traditional Events",
    icon: Flame,
    color: "orange",
  },
  {
    id: "service_14",
    available: true,
    description:
      "Whatever the occasion, our luxurious facilities are the perfect backdrop for your event.",
    title: "Other Events",
    icon: MoreHorizontal,
    color: "violet",
  },
];
